<template>
  <div class="card d-flex flex-column justify-content-start">
    <a
        :href="url('/catalog/' + macrofamiglia.codice)"
        class="d-flex align-items-center" >
    <img v-if="macrofamiglia.codice === 'CIN'"
         :src="url('/media/vetrina/CIN.jpg')"
         :alt="macrofamiglia.codice + ' image'"
    />
    <img v-if="macrofamiglia.codice === 'NAS'"
         :src="url('/media/vetrina/NAS.jpg')"
         :alt="macrofamiglia.codice + ' image'"
    />
    </a>
    <div class="my-text">
      <div class="row">
        <div class="col-md-12 description">
          <a
              :href="url('/catalog/' + macrofamiglia.codice)"
              class="d-flex align-items-center">
            <h3 class="my-caps">{{ macrofamiglia.descrizione }}</h3>
          </a>
          <p v-if="macrofamiglia.codice === 'CIN'">
            {{ trans.get('public.home.our-products.desc1') }}
          </p>
          <p v-else-if="macrofamiglia.codice === 'NAS'">
            {{ trans.get('public.home.our-products.desc2') }}
          </p>
        </div>
      </div>
    </div>
    <div class="scopri text-right">
      <a
          :href="url('/catalog/' + macrofamiglia.codice)"
          class="d-flex align-items-center"
      >{{ trans.get('public.explore') }}
        <img
            class="pointer"
            :src="url('/media/icons/svg/arrow-right_white.svg')"
            alt=""
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ns-prodotti-card",
  props: ["macrofamiglia"],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.card {
  font-size: 1em;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);

  }
  min-height: 100%;

  h2 {
    font-weight: normal;
  }

  @media (max-width: 576px) {
    min-height: 100%;
  }

  .my-text {
    padding: 20px;
    @media (max-width: 576px) {

    }

    .description {
      h3.my-caps {
        color: var(--greenb2b);
        @media (max-width: 576px) {

          margin-bottom: 13px;
        }
      }

      p {
        @media (max-width: 576px) {

        }
      }

      @media (max-width: 576px) {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  background-color: #2f2f34 !important;

  .scopri {
    color: #fff;
    margin-left: auto;
    margin-top: auto;
    margin-right: 35px;
    margin-bottom: 30px;
    width: 30%;

    a {
      justify-content: flex-end;
      margin-right: 20px;
    }

    @media (max-width: 576px) {
      right: 40px;

    }

    img {
      margin-left: 10px;
      transition: all 0.5s linear;
      width: 30px;
      height: 13px;
    }

    &:hover {
      img {
        left: 90px;
      }
    }

    a:hover {
      color: unset;
    }
  }
}

.row {
  color: #fff;

  h3 {
    color: #fff;
  }
}

@media (min-width: 1921px) {


}
</style>
